var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10213",
    "data-name": "Group 10213",
    transform: "translate(-330.5 -506.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1837",
    "data-name": "Ellipse 1837",
    className: "cls-1",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(331 507)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8168",
    "data-name": "Group 8168",
    transform: "translate(399.764 -535.719) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    className: "cls-1",
    d: "M0,0,2.465,2.439,4.877,0",
    transform: "translate(701.664 783.498) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    className: "cls-1",
    d: "M0,2.439,2.465,0,4.877,2.439",
    transform: "translate(699.225 783.498) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.0b0774f914b281defa8ff4817cd3f3e0.svg";
export { ForwardRef as ReactComponent };